import { PayloadAction } from "@reduxjs/toolkit";
import { QuoteCreateState } from "../types";

const quoteReducers = {
  setQuote: (state: QuoteCreateState, action: PayloadAction<Partial<any>>) => {
    if (!state.quote) state.quote = {};

    state.quote = {
      ...state.quote,
      ...action.payload,
    };
  },

  setDepositAmount: (state: QuoteCreateState, action: PayloadAction<number>) => {
    if (!state.quote) state.quote = {};

    state.quote = {
      ...state.quote,
      depositAmount: action.payload,
    };
  },

  setDepositPercent: (state: QuoteCreateState, action: PayloadAction<number | null>) => {
    if (!state.quote) state.quote = {};

    state.quote = {
      ...state.quote,
      depositPercent: action.payload,
    };
  },

  setPaymentMethod: (state: QuoteCreateState, action: PayloadAction<any>) => {
    if (!state.quote) state.quote = {};

    state.quote = {
      ...state.quote,
      paymentMethod: action.payload,
    };
  },

  clearQuote: (state: QuoteCreateState) => {
    state.quote = null;
  },
};

export default quoteReducers;
